import React from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '../../utils/cn';

/**
 * Breadcrumb — fil d'Ariane.
 *
 * Props :
 *   - items : [{ label, href?, icon? }]
 *   - LinkComponent : composant lien (ex: Link de react-router-dom).
 *     Si fourni, utilisé pour les items avec href au lieu d'un <a> natif
 *     (qui recharge la page en SPA).
 */
export function Breadcrumb({ items = [], separator, LinkComponent, className, ...rest }) {
  const sep = separator || <ChevronRight className="w-3.5 h-3.5 text-mute-2" strokeWidth={1.8} />;
  const LinkTag = LinkComponent;
  return (
    <nav aria-label="Fil d'Ariane" className={cn('flex items-center gap-1.5 text-sm', className)} {...rest}>
      {items.map((it, i) => {
        const isLast = i === items.length - 1;
        const content = it.icon ? (
          <span className="flex items-center gap-1.5">{it.icon}{it.label}</span>
        ) : it.label;
        const linkCls = 'text-mute hover:text-text transition-colors';
        return (
          <React.Fragment key={i}>
            {it.href && !isLast ? (
              LinkTag
                ? <LinkTag to={it.href} className={linkCls}>{content}</LinkTag>
                : <a href={it.href} className={linkCls}>{content}</a>
            ) : (
              <span className={cn(isLast ? 'text-text font-medium' : 'text-mute', 'truncate max-w-[260px]')} aria-current={isLast ? 'page' : undefined}>{content}</span>
            )}
            {!isLast && sep}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export default Breadcrumb;
